<div class="container">
  <content-loader height="300" width="1200" primaryColor="#eee" secondaryColor="#ddd">
    <svg:rect x="20" y="25" height="18" width="200" />
    <svg:rect x="20" y="110" height="30" width="400" />
    <svg:rect x="20" y="160" height="18" width="800" />
    <svg:rect x="20" y="190" height="18" width="400" />
  </content-loader>
</div>
